module.exports = __webpack_public_path__ + "static/img/logo63.cd20342.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo63.png
// module id = fCE6
// module chunks = 1